import { render } from "./FaoliyatJurnali.vue?vue&type=template&id=625c473a&scoped=true"
import script from "./FaoliyatJurnali.vue?vue&type=script&lang=js"
export * from "./FaoliyatJurnali.vue?vue&type=script&lang=js"

import "./FaoliyatJurnali.vue?vue&type=style&index=0&id=625c473a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625c473a"]])

export default __exports__